const config = {
  DEBUG_MODE: true,
  E2E_ATTR_NAME: "npkencrypt",
  /**
   * TBD
   * Update Application URL
   */
  // APPLICATION_URL: "/commonbiz/nppfs.servlet.do",
  APPLICATION_URL:
    (process.env.VUE_APP_API_CALL == "local"
      ? `${process.env.VUE_APP_SERVER_LOCAL}:${process.env.VUE_APP_INCA_SERVLET_PORT_LOCAL}`
      : process.env.NODE_ENV == "local" || document.location.host.indexOf(`web.${process.env.VUE_APP_DOMAIN}`) > -1
      ? `${process.env.VUE_APP_SERVER_PROTOCOL}://${process.env.VUE_APP_SERVER_DOMAIN}`
      : process.env.NODE_ENV == "development"
      ? ""
      : "") + "/commonbiz/nppfs.servlet.do",

  SECUKEY: {
    "npk-use-focus-reset": true, // 입력양식 클릭/포커스시에 값 초기화여부
  },

  // 입력값 포맷핑
  // type : 포맷 형식
  // value : 값
  // isInput : true: 데이터 포맷지정, false: 데이터 포맷 삭제
  FORMATTER: function (type, value, isInput) {
    let ret = value;
    switch (type) {
      case "dot3":
        if (isInput) {
          const arr = [];
          for (let i = 0; i < value.length; i++) {
            const val = value.substring(value.length - i - 1, value.length - i);
            // console.log(val);
            arr.unshift(val);
            if (i > 0 && i % 3 === 2 && i < value.length - 1) {
              arr.unshift(",");
            }
          }
          // console.log(arr);
          ret = arr.join("");
        } else {
          ret = value.split(",").join("");
        }
        break;
    }
    return ret;
  },

  /************************************************************
   * 가상키패드 강제사용정책 적용
   ***********************************************************/
  isAbsoluteUse: function (callback) {
    let useyn = false;
    if (callback && typeof callback === "function") {
      callback(useyn);
    }
    return useyn;
  },

  COLOR: {
    "on-text-color": "#000000",
    "on-back-color": "#ffcc00",
    "off-text-color": "",
    "off-back-color": "",
  },

  KEYPAD: {
    version: "1.13.0", // 마우스입력기 버전
    "outside-hide": true, // 마우스입력기 외부영역 클릭시 숨기기
    "outside-close": true, // 마우스입력기 외부영역 클릭시 비활성화

    "use-npk": false, // 키보드보안 사용여부

    "kpd-e2e-mode": "inca-encrypt", // 암호화방식
    "kpd-e2e-vendor": "", // E2E Vendor

    "kpd-run-type": "dual", // 동작방식 : single, dual(default)

    "kpd-active-class": "kpd-active",

    "kpd-multi-cursor": false, // 다중 마우스 커서
    "kpd-multi-cursor-image":
      "data:image/gif;base64,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",

    "kpd-use-aria": true, // 시각장애인 지원
    "kpd-use-aria-mobile": true, // 모바일에서만 시각장애인 지원

    "kpd-preview-border": 2, // 미리보기 버튼 테두리 두께
    "kpd-preview-timeout": 2000, // 미리보기 노출 시간
    "kpd-close-hide": true, // 숨기기 버튼 클릭 시 마우스입력기 비활성화 하기
  },
};

// module.exports = config;
export default config;
